module.exports = __webpack_public_path__ + "img/133ne.8b6ce14e.svg";